import * as Yup from 'yup';

export const recoverPasswordValidationSchema = Yup.object().shape({
  password: Yup.string().required('Required'),
  confirmPassword: Yup.string()
    .required('Required')
    .test('are-password-same', 'Password is not the same', function (value) {
      return this.parent.password === value;
    }),
});
